/**
 * Compact display name for a driver — first name, truncated to ≤8 chars with
 * a trailing ellipsis. Used for the REF lap chip when the reference is a
 * named driver.
 */
export function shortName(fullName: string): string {
  const first = fullName.trim().split(/\s+/)[0] ?? '';
  if (first.length <= 8) return first;
  return first.slice(0, 7) + '…';
}
